import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleSignIn() {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function AuthCallback() {
  const { googleSignIn, setUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    googleSignIn(sessionId)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => {
        toast.error(errorMessage(e, "Google sign-in failed. Please try again."));
        setUser(false);
        navigate("/login", { replace: true });
      });
  }, [googleSignIn, setUser, location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="auth-callback">
      <div className="animate-pulse"><Brand size="lg" /></div>
    </div>
  );
}

const GoogleMark = () => (
  <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export function GoogleButton({ label = "Continue with Google" }) {
  return (
    <button
      type="button"
      onClick={startGoogleSignIn}
      data-testid="google-signin-btn"
      className="flex w-full items-center justify-center gap-3 rounded-full border border-line bg-ivory px-6 py-3 text-sm font-semibold text-ink transition-[background-color,transform] duration-200 hover:bg-white active:scale-[0.98]"
    >
      <GoogleMark /> {label}
    </button>
  );
}
